import { logger } from '@/monitoring/logger'

type SupportChatLogLevel = 'info' | 'warn' | 'error'

type SupportChatLogProps = Record<string, unknown>

const SENSITIVE_KEYS = [
  'token',
  'jwt',
  'email',
  'document',
  'context',
  'payload',
]

const isSensitiveKey = (key: string) =>
  SENSITIVE_KEYS.some(sensitiveKey => key.toLowerCase().includes(sensitiveKey))

const sanitizeLogProps = (props: SupportChatLogProps) =>
  Object.entries(props).reduce<SupportChatLogProps>((acc, [key, value]) => {
    if (isSensitiveKey(key)) {
      return acc
    }

    if (typeof value === 'object' && value !== null) {
      acc[key] = '[redacted-object]'
      return acc
    }

    acc[key] = value
    return acc
  }, {})

const log = (
  level: SupportChatLogLevel,
  message: string,
  props: SupportChatLogProps = {}
) => {
  logger[level](message, {
    area: 'support_chat',
    ...sanitizeLogProps(props),
  })
}

export const supportChatLogger = {
  info: (message: string, props?: SupportChatLogProps) =>
    log('info', message, props),
  warn: (message: string, props?: SupportChatLogProps) =>
    log('warn', message, props),
  error: (message: string, props?: SupportChatLogProps) =>
    log('error', message, props),
}
